import React from 'react';
import { Hero } from './components/Hero';
import { Problem } from './components/Problem';
import { Solution } from './components/Solution';
import { WhatsIncluded } from './components/WhatsIncluded';
import { Benefits } from './components/Benefits';
import { Bonuses } from './components/Bonuses';
import { Testimonials } from './components/Testimonials';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { StickyMobileCTA } from './components/StickyMobileCTA';
export function App() {
  return <div className="w-full min-h-screen bg-white pb-20 md:pb-0" data-id="element-0">
      <Hero data-id="element-1" />
      <Problem data-id="element-2" />
      <Solution data-id="element-3" />
      <WhatsIncluded data-id="element-4" />
      <Benefits data-id="element-5" />
      <Bonuses data-id="element-6" />
      <Testimonials data-id="element-7" />
      <FAQ data-id="element-8" />
      <FinalCTA data-id="element-9" />
      <StickyMobileCTA data-id="element-10" />
    </div>;
}